import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    setTimeout(() => {
      const modalElement = document.getElementById("app-modal")
      const modal = Modal.getInstance(modalElement)
      if (modal) modal.hide()
    }, 500)
  }
}
